import { render, staticRenderFns } from "./MicrositePhoto.vue?vue&type=template&id=462be4af&scoped=true&"
import script from "./MicrositePhoto.vue?vue&type=script&lang=ts&"
export * from "./MicrositePhoto.vue?vue&type=script&lang=ts&"
import style0 from "./MicrositePhoto.vue?vue&type=style&index=0&id=462be4af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462be4af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
